export default "__VITE_ASSET__B7spQC7x__"